var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeNotifyArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5896,
    cy: 25.0242,
    r: 24.8386,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5666 25.0279L30.4227 17.1715C30.639 16.9557 30.758 16.6671 30.758 16.3595C30.758 16.0517 30.639 15.7633 30.4227 15.5471L29.7343 14.8591C29.5183 14.6426 29.2296 14.5234 28.9219 14.5234C28.6143 14.5234 28.3259 14.6426 28.1098 14.8591L18.7559 24.2128C18.5389 24.4296 18.42 24.7194 18.4209 25.0274C18.42 25.3367 18.5387 25.6261 18.7559 25.8431L28.101 35.1878C28.3172 35.4043 28.6056 35.5234 28.9134 35.5234C29.221 35.5234 29.5094 35.4043 29.7257 35.1878L30.414 34.4997C30.8618 34.0519 30.8618 33.3229 30.414 32.8752L22.5666 25.0279Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNotifyArrow);
export default __webpack_public_path__ + "static/media/home_notify_arrow.6a09eceba0def4ca73f5d71128f69136.svg";
export { ForwardRef as ReactComponent };